import React, { useState, useEffect, Component } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
// import axios, { AxiosResponse } from 'axios';
import Alert from '@material-ui/lab/Alert/Alert';
/* import { Viewer } from '@react-pdf-viewer/core'; */
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import DeleteIcons from '@material-ui/icons/Delete'
import ViewIcons from '@material-ui/icons/Visibility'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, InputLabel, Paper, PaperProps } from '@material-ui/core'
import { CircularProgress, Grid, Link } from '@material-ui/core';
import { ObtieneDatosPersonalesLogic, ObtieneDatosTipoPersonaPorPostulacionLogic, useStyles } from '../../../view-model/DatosPersonales/DatosPersonales.logic';
import { UpdateEtapaProcesoLogic } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
import { ObtieneEtapasLogic, ObtieneSiguienteEtapaLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import IViewDatosPersonales from '../../../view-interfaces/IViewDatosPersonales';
import IViewEtapas from '../../../view-interfaces/IViewEtapas';
import { format } from 'fecha';
import f1 from '../../../../assets/dist/svg/main.svg';
import IViewDocumentos from "../../../../presentation/view-interfaces/IViewDocumentos";

import IViewTipoPersona from '../../../view-interfaces/IViewTipoPersona';
import { ObtieneContratoLogic, eCert_firmaLogic, ObtieneFirmaLogic, ObtieneExcepcionLogic, ObtieneExcepcionProgramaLogic, ObtieneContratoManualLogic, QuitarContratoManualLogic, InsertaContratoManualLogic, BajarContratoManualLogic } from '../../../view-model/Contrato/Contrato.logic';
// import { Element } from 'domhandler';
// import IcartPopUp from '../../../view-model/Modals/Ecert';
// import { getDate } from 'date-fns';
import { useDocument, useWindow } from '@fluentui/react-window-provider';
import { ResponsableFinanciero } from '../DatosPersonales/ResponsableFinanciero';

import { con } from "../../../../application/entity/Rutas";
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';

type Props = {
    rut: number;
    codCarrera: string;
    codigoNegocio: number;
    anioPromocion: number;
    periodoPromocion: number;
    onClickContinuar: any;
}

export const FirmaContrato: React.FC<Props> = ({ rut, codCarrera, codigoNegocio, anioPromocion = 0, periodoPromocion = 0, onClickContinuar }) => {
    const history = useHistory();
    const location = useLocation();

    const win = useWindow();
    const doc = useDocument();

    const [idProcesoPostulante, setIdProcesoPostulante] = useState(0);
    const [validado, setValidado] = useState(0);
    const [openIFrameAlumno, setOpenIFrameAlumno] = useState(false);
    const [openIFrameRF, setOpenIFrameRF] = useState(false);
    const [openIFrameRL, setOpenIFrameRL] = useState(false);
    const [openRespuesta, setOpenRespuesta] = useState(false);

    const lista: Array<IViewDatosPersonales> = [];
    const [postulante, setPostulante] = useState(lista);

    const [nombre1, setNombre1] = useState('');
    const [rutCompleto1, setRutCompleto1] = useState(0);
    const [runFormato1, setRunFormato1] = useState('');
    const [nombreCompleto1, setNombreCompleto1] = useState('');
    const [firmado1, setFirmado1] = useState(false);

    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const [check3, setCheck3] = useState(false);

    const [nombre2, setNombre2] = useState('');
    const [rutCompleto2, setRutCompleto2] = useState(0);
    const [runFormato2, setRunFormato2] = useState('');
    const [nombreCompleto2, setNombreCompleto2] = useState('');
    const [firmado2, setFirmado2] = useState(false);
    const [idTipo1, setIdTipo1] = useState(1);
    const [idTipo2, setIdTipo2] = useState(1);
    const [idTipo3, setIdTipo3] = useState(1);

    const [nombre3, setNombre3] = useState('');
    const [rutCompleto3, setRutCompleto3] = useState(0);
    const [runFormato3, setRunFormato3] = useState('');
    const [nombreCompleto3, setNombreCompleto3] = useState('');
    const [firmado3, setFirmado3] = useState(false);

    const listaRF: Array<IViewTipoPersona> = [];
    const [representanteFinanciero, setRepresentanteFinanciero] = useState(listaRF);
    const [representanteLegal, setRepresentanteLegal] = useState(listaRF);
    const listaAseg: Array<IViewTipoPersona> = [];
    const [asegurado, setAsegurado] = useState(listaAseg);
    const listaCont: Array<IViewTipoPersona> = [];
    const [contacto, setContacto] = useState(listaCont);

    const [loading, setLoading] = useState(false);

    //const [rutAlumno, setRutAlumno] = useState(0);
    const [numeroAlumno, setNumeroAlumno] = useState('');
    const [añoPromocion, setAñoPromocion] = useState(0);
    // const [periodoPromocion, setPeriodoPromocion] = useState(0);
    const [myhtmlAlumno, setmyhtmlAlumno] = useState<string>('');
    const [myhtmlRF, setmyhtmlRF] = useState<string>('');

    const [tokenAlumno, setTokenAlumno] = useState('');
    const [tokenRF, setTokenRF] = useState('');
    const [ok, setOk] = useState('');
    /* const newContext = React.createContext(myhtml); */

    const [sigEtapa, setSigEtapa] = useState('');
    const listaEtapas: Array<IViewEtapas> = [];
    const [etapas, setEtapas] = useState(listaEtapas);

    const [cargandoValores, setCargandoValores] = useState(true)

    const [firma1, setFirma1] = useState(0);
    const [firma2, setFirma2] = useState(0);
    const [firma3, setFirma3] = useState(0);
    const [firma1Check, setFirma1Check] = useState(false);
    const [firma2Check, setFirma2Check] = useState(false);
    const [firma3Check, setFirma3Check] = useState(false);

    const [cargandoContrato, setCargandoContrato] = useState(false);

    const [error, setError] = useState(false);
    const [reintentar, setReintentar] = useState(false);

    const [tieneExcepcion, setTieneExcepcion] = useState(false);
    const [docSubido, setDocSubido] = useState('');
    const [subiendoDoc, setSubiendoDoc] = useState(false);
    const [errorsubida, setErrorSubida] = useState(false);
    const Doc: Array<IViewDocumentos> = [];
    // const [listaDoc, setListaDoc] = useState(Doc);
    const [allUploaded, setAllUploaded] = useState(false);
    const [cod, setCod] = useState(0);
    const [eliminandoDoc, setEliminandoDoc] = useState(false);
    const [eliminarDoc, setEliminarDoc] = useState(false);
    const [formatoIncorrecto, setFormatoIncorrecto] = useState(false);
    const [txtformatoIncorrecto, setTxtFormatoIncorrecto] = useState("");

    const [errorVentanasEmergentes, setErrorVentanasEmergentes] = useState(false);
    const [errorEtapas, setErrorEtapas] = useState(false);

    const [mnsjeCert, setMnsjeCert] = useState(con.mnsjeCert());

    const [notieneRF, setNoTieneRF] = useState(true);

    const [esMenorEdad, setEsMenorEdad] = useState(false);

    const [codigoNegocioPostulante, setCodigoNegocioPostulante] = useState(0);
    const [debeFirmar, setDebeFirmar] = useState(false);
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
  const [codNegocio, setCodNegocio] = useState(0)

    useEffect(() => {
        if (reintentar) {
            setError(false)
            if (location.state === null || location.state === undefined) {
                history.push({
                    pathname: "/Inicio"
                });
            } else {
                handleCargaDatosIniciales();
            }
            setReintentar(false);
        }
    }, [reintentar])
    useEffect(() => {
        console.log("que esta pasando");
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        codigoNegocio = _params.codigoNegocio;
        setCodigoNegocioPostulante(codigoNegocio);
        setDebeFirmar(_params.debeFirmar);

        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });

        } else {
            setCod(con.codDocumentoContrato());
            let _cod: string = con.codExceptionFirma();
            // let tipoExcepcion = _cod.split(',')[0];
            let codExcepcion = _cod.split(',')[1];
            ObtieneExcepcionLogic(selResultadoExcepcion, _params.rut, parseInt(codExcepcion), _params.codigoNegocio, 0, 0, _params.codCarrera);
            handleCargaDatosIniciales();
        }
    }, [])

    const selResultadoExcepcion = (error: Boolean, err: string, Resultado: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let _cod: string = con.codExceptionFirma();
        let codExcepcion = _cod.split(',')[1]
        try {
            /* console.log(Resultado) */
            if (Resultado) {
                setTieneExcepcion(Resultado);
                ObtenerListadoDocumentos();
            } else {
                ObtieneExcepcionProgramaLogic(selResultadoExcepcionPrograma, parseInt(codExcepcion), _params.codigoNegocio, _params.codCarrera, _params.anioPromocion, _params.periodoPromocion, _params.codigoPlanificacionAcademica);
            }
        } catch (err) {
            console.log('error', err);
        }

    }
    const selResultadoExcepcionPrograma = (error: Boolean, err: string, Resultado: any) => {
        try {
            /* console.log(Resultado) */
            setTieneExcepcion(Resultado);
            ObtenerListadoDocumentos();
        } catch (err) {
            console.log('error', err);
        }

    }
    const selListaManual = (error: Boolean, err: string, result: any) => {
        if (error === false && lista !== undefined) {
            console.log(result.length > 0);
            setAllUploaded(result.length > 0);
            setSubiendoDoc(false);
            setCargandoValores(false);
        } else {
            setError(true);
        }
    }
    const selVerManual = (error: Boolean, err: string, result: any) => {

    }
    useEffect(() => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        if (firma1 !== 0) {
            if (firma1 === 1) {
                //ObtieneDatosPostulanteLogic(selListaPostulante, rut, codigoNegocio);
                ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, rut, "", codigoNegocio, 1, _params.idPeriodo/* , "12841298asd" */);
            } else if (firma1 === 2) {
                //ObtieneRepresentanteFinancieroLogic(selListaRepresentanteFinanciero, rut, codCarrera, codigoNegocio, "");
                ObtieneDatosTipoPersonaPorPostulacionLogic(selListaRepresentanteFinanciero, _params.headers, rut, codigoNegocio, codCarrera, anioPromocion, periodoPromocion, 0, 2, _params.idPeriodo);
            } else if (firma1 === 3) {
                //ObtieneAseguradoLogic(selListaAsegurado, rut, codCarrera, codigoNegocio);
                ObtieneDatosTipoPersonaPorPostulacionLogic(selListaAsegurado, _params.headers, rut, codigoNegocio, codCarrera, anioPromocion, periodoPromocion, 0, 3, _params.idPeriodo);
            } else if (firma1 === 4) {
                //ObtieneContactoLogic(selListaContacto, rut, codCarrera, codigoNegocio);
                ObtieneDatosTipoPersonaPorPostulacionLogic(selListaContacto, _params.headers, rut, codigoNegocio, codCarrera, anioPromocion, periodoPromocion, 0, 4, _params.idPeriodo);
            }
        }
        if (firma2 !== 0) {
            if (firma2 === 1) {
                //ObtieneDatosPostulanteLogic(selListaPostulante, rut, codigoNegocio);
                ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, rut, "", codigoNegocio, 1, _params.idPeriodo);
            } else if (firma2 === 2) {
                //ObtieneRepresentanteFinancieroLogic(selListaRepresentanteFinanciero, rut, codCarrera, codigoNegocio, "");
                ObtieneDatosTipoPersonaPorPostulacionLogic(selListaRepresentanteFinanciero, _params.headers, rut, codigoNegocio, codCarrera, anioPromocion, periodoPromocion, 0, 2, _params.idPeriodo);
            } else if (firma2 === 3) {
                //ObtieneAseguradoLogic(selListaAsegurado, rut, codCarrera, codigoNegocio);
                ObtieneDatosTipoPersonaPorPostulacionLogic(selListaAsegurado, _params.headers, rut, codigoNegocio, codCarrera, anioPromocion, periodoPromocion, 0, 3, _params.idPeriodo);
            } else if (firma2 === 4) {
                //ObtieneContactoLogic(selListaContacto, rut, codCarrera, codigoNegocio);
                ObtieneDatosTipoPersonaPorPostulacionLogic(selListaContacto, _params.headers, rut, codigoNegocio, codCarrera, anioPromocion, periodoPromocion, 0, 4, _params.idPeriodo);
            }
        }
    }, [firma1, firma2])



    const handleCargaDatosIniciales = () => {
        sessionStorage.setItem('fase', JSON.stringify('firmaContrato'));
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        /* console.log(_params) */
        setIdProcesoPostulante(Number(_params.idProceso));
        setNumeroAlumno(_params.numeroAlumno);
        setAñoPromocion(_params.anioPromocion);
        ObtieneEtapasLogic(selListaEtapas, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, _params.rut, _params.anioPromocion, _params.periodoPromocion);
        /* EnviarTokenLogic(selInsertToken,'8785c694-0215-4548-bd17-6ac92c9c5fa6') */
    }

    const selListaRepresentanteLegal = (error: Boolean, err: string, Persona: any) => {
        console.log(Persona);
        try {
            if (error === false && Persona.length > 0) {
                setRepresentanteLegal(Persona);
                // setRutCompletoRL(Persona[0].runFormato);
                // setNombreCompletoRL(Persona[0].nombreCompleto);
                setRutCompleto3(Persona[0].run);
                setRunFormato3(Persona[0].runFormato);
                setIdTipo3(5);
                setNombreCompleto3(Persona[0].nombreCompleto);
                setNombre3('Resp. Legal');
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
    }

    const selListaEtapas = (error: Boolean, err: string, Etapas: any) => {
        if (error === false && Etapas !== undefined) {
            setEtapas(Etapas);
            Etapas.map((e: any) => {
                if (e.idEtapa === 1) {
                    setValidado(e.estado);
                }
            })

        }
    }

    const selListaPostulante = (error: Boolean, err: string, Estudiante: any) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (error === false && Estudiante[0].run.toString().trim().length > 1) {
                let _postulante: Array<IViewDatosPersonales> = [];

                _postulante.push({
                    idPersona: Estudiante[0].idPersona,
                    run: Estudiante[0].run,
                    dv: Estudiante[0].dv.trim(),
                    pasaporte: Estudiante[0].pasaporte.trim(),
                    nombres: Estudiante[0].nombres.trim(),
                    primerApellido: Estudiante[0].primerApellido.trim(),
                    segundoApellido: Estudiante[0].segundoApellido.trim(),
                    fechaNacimiento: format(new Date(Estudiante[0].fechaNacimiento), 'YYYY-MM-DD'),
                    esMenorEdad: Estudiante[0].esMenorEdad,
                    codigoComuna: Estudiante[0].codigoComuna,
                    nombreComuna: Estudiante[0].nombreComuna.trim(),
                    direccion: Estudiante[0].direccion.trim(),
                    telefono: Estudiante[0].telefono,
                    email: Estudiante[0].email.trim(),
                    emailUDD: Estudiante[0].emailUDD.trim(),
                    codSexo: Estudiante[0].codSexo,
                    sexo: Estudiante[0].sexo.trim(),
                    idPais: Estudiante[0].idPais,
                    pais: Estudiante[0].pais.trim(),
                    idNacionalidad: Estudiante[0].idNacionalidad,
                    nacionalidad: Estudiante[0].nacionalidad.trim(),
                    runFormato: Estudiante[0].runFormato,
                    nombreCompleto: Estudiante[0].nombreCompleto
                });

                setPostulante(_postulante);
                setEsMenorEdad(Estudiante[0].esMenorEdad);

                if (Estudiante[0].esMenorEdad && codigoNegocio === 1) {
                    ObtieneDatosTipoPersonaPorPostulacionLogic(selListaRepresentanteLegal, _params.headers, rut, codigoNegocio, codCarrera, anioPromocion, periodoPromocion, 0, 5, _params.idPeriodo);
                }

                if (firma1 === 1) {
                    setRutCompleto1(Estudiante[0].run);
                    setRunFormato1(Estudiante[0].runFormato);
                    setIdTipo1(1);
                    setNombreCompleto1(Estudiante[0].nombreCompleto);
                    setNombre1('Alumno');
                }
                if (firma2 === 1) {
                    setRutCompleto2(Estudiante[0].run);
                    setRunFormato2(Estudiante[0].runFormato);
                    setIdTipo2(1);
                    setNombreCompleto2(Estudiante[0].nombreCompleto);
                    setNombre2('Alumno');
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }

        } catch (error) {
            console.log('error', error);
        }
    }

    const selListaRepresentanteFinanciero = (
        error: Boolean, err: string, list: Array<IViewTipoPersona>) => {
        try {
            if (error === false && list.length > 0) {
                setRepresentanteFinanciero(list);
                // setRutCompletoRF(list[0].runFormato);
                // setNombreCompletoRF(list[0].nombreCompleto);
                if (firma1 === 2) {
                    setRutCompleto1(list[0].run);
                    setRunFormato1(list[0].runFormato);
                    setIdTipo1(2);
                    setNombreCompleto1(list[0].nombreCompleto);
                    setNombre1('Resp. Financiero');
                }
                if (firma2 === 2) {
                    setRutCompleto2(list[0].run);
                    setRunFormato2(list[0].runFormato);
                    setIdTipo2(2);
                    setNombreCompleto2(list[0].nombreCompleto);
                    setNombre2('Resp. Financiero');
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
    }

    const selListaAsegurado = (
        error: Boolean, err: string, list: Array<IViewTipoPersona>) => {
        try {
            if (error === false && list.length > 0) {
                setAsegurado(list);
                // setRutCompletoAseg(list[0].runFormato);
                // setNombreCompletoAseg(list[0].nombreCompleto);
                if (firma1 === 3) {
                    setRutCompleto1(list[0].run);
                    setRunFormato1(list[0].runFormato);
                    setIdTipo1(3);
                    setNombreCompleto1(list[0].nombreCompleto);
                    setNombre1('Asegurado');
                }
                if (firma2 === 3) {
                    setRutCompleto2(list[0].run);
                    setRunFormato2(list[0].runFormato);
                    setIdTipo2(3);
                    setNombreCompleto2(list[0].nombreCompleto);
                    setNombre2('Asegurado');
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
    }

    const selListaContacto = (
        error: Boolean, err: string, list: Array<IViewTipoPersona>) => {
        try {
            if (error === false && list.length > 0) {
                setContacto(list);
                // setRutCompletoCont(list[0].runFormato);
                // setNombreCompletoCont(list[0].nombreCompleto);
                if (firma1 === 4) {
                    setRutCompleto1(list[0].run);
                    setRunFormato1(list[0].runFormato);
                    setIdTipo1(4);
                    setNombreCompleto1(list[0].nombreCompleto);
                    setNombre1('Contacto');
                }
                if (firma2 === 4) {
                    setRutCompleto2(list[0].run);
                    setRunFormato2(list[0].runFormato);
                    setIdTipo2(4);
                    setNombreCompleto2(list[0].nombreCompleto);
                    setNombre2('Contacto');
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
    }

    const handleVisualizarContrato = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        setCargandoContrato(true);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        let idPersona = _params.idPeriodo === null ? 0 : _params.idPersona;
        //ObtieneContrato();
        //ObtieneContrato();
        //ObtieneContratoLogicPDF(selResultadoContrato, codigoNegocio, codCarrera, rut,true);
        ObtieneContratoLogic(selResultadoContrato, _params.headers, codigoNegocio, codCarrera, rut, false, _params.anioPromocion, _params.codigoPlanificacionAcademica, tieneExcepcion, idPeriodo, idPersona);
    }

    const handleFirmaContrato = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        /* console.log(_params) */
        setOpenIFrameAlumno(true);
        console.log("firmando contrato")
        eCert_firmaLogic(selResultadoFirmaAlumno, idProcesoPostulante, rutCompleto1, añoPromocion, _params.periodoPromocion, _params.numeroAlumno, 1, idPeriodo);
    }
    const handleFirmaContrato2 = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        // console.log("handleFirmaContrato2");
        // console.log(_params);
        // console.log(periodoPromocion);
        setOpenIFrameRF(true);
        eCert_firmaLogic(selResultadoFirmaRF, idProcesoPostulante, rutCompleto2, añoPromocion, _params.periodoPromocion, _params.numeroAlumno, idTipo2, idPeriodo);
    }

    const handleFirmaContrato3 = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        //ObtieneContrato();
        /* console.log(_params) */
        setOpenIFrameRL(true);
        eCert_firmaLogic(selResultadoFirmaRL, idProcesoPostulante, rutCompleto3, añoPromocion, _params.periodoPromocion, _params.numeroAlumno, 5, idPeriodo);
    }

    const selResultadoContrato = (error: Boolean, err: string, Resultado: any) => {
        try {
            console.log(error)
            if (error == false) {
                setCargandoContrato(false);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            console.log('error', err);
        }

    }

    const selResultadoFirmaAlumno = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                if (Resultado.token !== "") {
                    let url = (Resultado.url + "?Token=" + Resultado.token);
                    let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
                    var form = document.createElement("form");
                    form.setAttribute("method", "post");
                    form.setAttribute("action", url);

                    form.setAttribute("target", windowName);

                    var respuesta = window.open(url);

                    var timer = setInterval(function () {
                        try {
                            if (respuesta!.closed) {
                                let _tt = JSON.stringify(location.state);
                                let _params = JSON.parse(_tt);
                                let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
                                ObtieneFirmaLogic(selObtenerFirmaAlumno, codigoNegocio, idProcesoPostulante, idPeriodo, esMenorEdad);
                                clearInterval(timer);
                            }
                        }
                        catch (e: any) {
                            setErrorVentanasEmergentes(true);
                        }

                    }, 500);
                    form.submit();
                } else {
                    setErrorEtapas(true);
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const selResultadoFirmaRF = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                if (Resultado.token !== "") {
                    let url = (Resultado.url + "?Token=" + Resultado.token);
                    let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
                    var form = document.createElement("form");
                    form.setAttribute("method", "post");
                    form.setAttribute("action", url);

                    form.setAttribute("target", windowName);

                    var respuesta = window.open(url);

                    var timer = setInterval(function () {
                        try {
                            if (respuesta!.closed) {
                                let _tt = JSON.stringify(location.state);
                                let _params = JSON.parse(_tt);
                                let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
                                ObtieneFirmaLogic(selObtenerFirmaRF, codigoNegocio, idProcesoPostulante, idPeriodo, esMenorEdad);
                                clearInterval(timer);
                            }
                        }
                        catch (e: any) {
                            setErrorVentanasEmergentes(true);
                        }
                    }, 500);
                    form.submit();
                } else {
                    setErrorEtapas(true);
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const selResultadoFirmaRL = (error: Boolean, err: string, Resultado: any) => {
        console.log("ResultadoFirmaRL");
        try {
            if (error === false) {
                if (Resultado.token !== "") {
                    let url = (Resultado.url + "?Token=" + Resultado.token);
                    let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
                    var form = document.createElement("form");
                    form.setAttribute("method", "post");
                    form.setAttribute("action", url);

                    form.setAttribute("target", windowName);

                    var respuesta = window.open(url);

                    var timer = setInterval(function () {
                        try {
                            if (respuesta!.closed) {
                                let _tt = JSON.stringify(location.state);
                                let _params = JSON.parse(_tt);
                                let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
                                ObtieneFirmaLogic(selObtenerFirmaRL, codigoNegocio, idProcesoPostulante, idPeriodo, esMenorEdad);
                                clearInterval(timer);
                            }
                        }
                        catch (e: any) {
                            setErrorVentanasEmergentes(true);
                        }
                    }, 500);
                    form.submit();
                } else {
                    setErrorEtapas(true);
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    // const selInsertToken = (error: Boolean, err: string, Resultado: any) => {
    //     try {
    //         if (error === false) {
    //             let _tt = JSON.stringify(location.state);
    //             let _params = JSON.parse(_tt);
    //             let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
    //             ObtieneFirmaLogic(selObtenerFirma, codigoNegocio, idProcesoPostulante, idPeriodo);
    //         }
    //     } catch (err) {
    //         console.log('error', err);
    //     }
    // }

    const selObtenerFirma = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                // aquí
                console.log("selObtenerFirma")
                console.log(error);
                console.log(Resultado);
                setNoTieneRF(Resultado.length < 2);
                setFirma1Check(Resultado[0].contratoFirmado);
                setFirma1(Resultado[0].idTipoPersona);
                setCheck1(Resultado[0].contratoFirmado);
                if (Resultado.length > 1) {
                    setFirma2Check(Resultado[1].contratoFirmado);
                    setFirma2(Resultado[1].idTipoPersona);
                    setCheck2(Resultado[1].contratoFirmado);
                }
                if (Resultado.length > 2) {
                    setFirma3Check(Resultado[2].contratoFirmado);
                    setFirma3(Resultado[2].idTipoPersona);
                    setCheck3(Resultado[2].contratoFirmado);
                }

                if (Resultado.length > 1) {
                    if (!Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                        setFirmado1(false);
                        setFirmado2(true);
                        setFirmado3(true);
                    } else if (Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                        setFirmado1(true);
                        setFirmado2(false);
                    } else if (!Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                        setFirmado1(false);
                        setFirmado2(true);
                    } else if (Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                        setFirmado1(true);
                        setFirmado2(true);
                    }
                } else {
                    setFirmado1(Resultado[0].contratoFirmado);
                }


                setCargandoValores(false);
            } else {
                setError(true);
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const selObtenerFirmaRF = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                // aquí
                /* console.log(Resultado) */
                setFirma1Check(Resultado[0].contratoFirmado);
                setFirma1(Resultado[0].idTipoPersona);
                setCheck1(Resultado[0].contratoFirmado);
                setFirma2Check(Resultado[1].contratoFirmado);
                setFirma2(Resultado[1].idTipoPersona);
                setCheck2(Resultado[1].contratoFirmado);

                if (!Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                    setFirmado1(false);
                    setFirmado2(true);
                    setFirmado3(true);
                } else if (Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                    setFirmado1(true);
                    setFirmado2(false);
                } else if (!Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                    setFirmado1(false);
                    setFirmado2(true);
                } else if (Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                    setFirmado1(true);
                    setFirmado2(true);
                    setFirmado3(false);
                }

                if (Resultado[1].contratoFirmado) {
                    setOk('0');
                    setOpenRespuesta(true);
                    setOpenIFrameRF(false);
                } else {
                    setOk('Error');
                    setOpenRespuesta(true);
                    setOpenIFrameRF(false);
                }

            } else {
                setError(true);
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const selObtenerFirmaRL = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                // aquí
                /* console.log(Resultado) */
                setFirma1Check(Resultado[0].contratoFirmado);
                setFirma1(Resultado[0].idTipoPersona);
                setCheck1(Resultado[0].contratoFirmado);
                setFirma2Check(Resultado[1].contratoFirmado);
                setFirma2(Resultado[1].idTipoPersona);
                setCheck2(Resultado[1].contratoFirmado);
                setFirma3Check(Resultado[2].contratoFirmado);
                setFirma3(Resultado[2].idTipoPersona);
                setCheck3(Resultado[2].contratoFirmado);

                setFirmado1(Resultado[0].contratoFirmado);
                setFirmado2(Resultado[1].contratoFirmado);
                setFirmado3(Resultado[2].contratoFirmado);

                /*if (!Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                    setFirmado1(false)
                    setFirmado2(true)
                } else if (Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                    setFirmado1(true)
                    setFirmado2(false)
                } else if (!Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                    setFirmado1(false)
                    setFirmado2(true)
                } else if (Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                    setFirmado1(true)
                    setFirmado2(true)
                }*/


                if (Resultado[2].contratoFirmado) {
                    setOk('0');
                    setOpenRespuesta(true);
                    setOpenIFrameRL(false);
                } else {
                    setOk('Error');
                    setOpenRespuesta(true);
                    setOpenIFrameRL(false);
                }

            } else {
                setError(true);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const selObtenerFirmaAlumno = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                // aquí
                console.log(Resultado)
                setFirma1Check(Resultado[0].contratoFirmado);
                setFirma1(Resultado[0].idTipoPersona);
                setCheck1(Resultado[0].contratoFirmado);

                if (Resultado.length > 1) {
                    setFirma2Check(Resultado[1].contratoFirmado);
                    setFirma2(Resultado[1].idTipoPersona);
                    setCheck2(Resultado[1].contratoFirmado);
                }

                if (Resultado.length > 2) {
                    setFirma3Check(Resultado[2].contratoFirmado);
                    setFirma3(Resultado[2].idTipoPersona);
                    setCheck3(Resultado[2].contratoFirmado);
                }

                if (Resultado.length > 1) {
                    if (!Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                        setFirmado1(false);
                        setFirmado2(true);
                        setFirmado3(true);
                    } else if (Resultado[0].contratoFirmado && !Resultado[1].contratoFirmado) {
                        setFirmado1(true);
                        setFirmado2(false);
                    } else if (!Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                        setFirmado1(false);
                        setFirmado2(true);
                    } else if (Resultado[0].contratoFirmado && Resultado[1].contratoFirmado) {
                        setFirmado1(true);
                        setFirmado2(true);
                    }
                } else {
                    setFirmado1(Resultado[0].contratoFirmado);
                }

                if (Resultado[0].contratoFirmado) {
                    setOk('0');
                    setOpenRespuesta(true);
                    setOpenIFrameAlumno(false);
                } else {
                    setOk('Error');
                    setOpenRespuesta(true);
                    setOpenIFrameAlumno(false);
                }

            } else {
                setError(true);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    useEffect(() => {
        setLoading(true);
        setCargandoValores(true);
        setLoading(false);

    }, [rut])

    useEffect(() => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        ObtieneFirmaLogic(selObtenerFirma, codigoNegocio, _params.idProceso, idPeriodo);
    }, [asegurado, contacto, ResponsableFinanciero, postulante, representanteLegal])

    // const UpdateEtapaProceso = () => {
    //     /* onClickContinuar('7') */
    //     UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 6);
    // }

    const selUpdateEtapa = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            //console.log(data)
            /* onClickContinuar('7') */
            siguienteEtapa();
        }
    }
    const siguienteEtapa = () => {
        var contrato: boolean = true;
        var pago: boolean = false;
        /* console.log(etapas) */
        /* etapas.map((e: IViewEtapas) => {
            if (e.nombre === 'Pago Web-Pay') {
                pago = e.estado
            }
        }) */
        ObtieneSiguienteEtapaLogic(selSiguienteEtapa, contrato, pago);
    }
    const selSiguienteEtapa = (error: Boolean, err: string, Sig: any) => {
        if (error === false && Sig !== undefined) {
            /* console.log(Sig); */
            setSigEtapa(Sig.idEtapa.toString());
            onClickContinuar(Sig.idEtapa.toString());
            /* UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante,1); */
        }
    }
    useEffect(() => {
        if (/* firmado1 && firmado2 */check1 && (notieneRF ? true : check2) && (esMenorEdad ? check3 : true) && etapas.length > 0 && !openRespuesta) {
            /*  console.log("Generando Matricula....") */
            UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 6);
        }

    }, [firmado1, firmado2, firmado3, etapas, openRespuesta])

    const getBase64 = (file: any) => {
        return new Promise(resolve => {
            //let fileInfo;
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result !== null ? reader.result.toString() : '';
                resolve(baseURL);
            };
        });
    };

    const handleFileInputChange = (e: any) => {
        setErrorSubida(false);
        console.log(e.target.files[0]);
        let file: any;

        file = e.target.files[0];
        let extension = file.type.split('/')[1];

        getBase64(file)
            .then(result => {
                file["base64"] = result;

                let fecha = new Date();

                if (extension === 'pdf' || extension === 'PDF') {
                    /* if (file.size > 6000000) {
                        setDocSubido(fecha.toString())
                        setFormatoIncorrecto(true)
                        setTxtFormatoIncorrecto("El archivo debe tener un tamaño máximo de 6mb (6.000Kb)")
                    } else { */
                    setFormatoIncorrecto(false);
                    InsertarDocumentos(e.target.name.split('/')[1], extension, file.base64.split('base64,')[1]);
                    /* } */
                } else {
                    setDocSubido(fecha.toString());
                    setFormatoIncorrecto(true);
                    setTxtFormatoIncorrecto("Formato del documento solo puede ser PDF");
                }
            })
            .catch(err => {
                console.log(err);
            })

    }
    const InsertarDocumentos = (idDoc: number, extension: string, base64: string) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        setSubiendoDoc(true);
        setErrorSubida(false);
        InsertaContratoManualLogic(selInsertDocumentos, _params.rut, _params.idProceso, _params.anioPromocion, _params.periodoPromocion, _params.numeroAlumno, base64, _params.idPeriodo);
    }

    const selInsertDocumentos = (error: Boolean, err: string, result: boolean) => {
        if (error === false && result !== undefined) {
            /* console.log(result) */
            setErrorSubida(!result);
        } else {
            setErrorSubida(true);
        }
        setSubiendoDoc(false);
        let fecha = new Date();
        setDocSubido(fecha.toString());
        ObtenerListadoDocumentos();
    }

    const ObtenerListadoDocumentos = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        ObtieneContratoManualLogic(selListaManual, _params.rut, _params.idProceso);
    }

    const VerContratoManual = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        BajarContratoManualLogic(selVerManual, _params.rut, _params.idProceso);
    }

    const EliminarDocumentos = (idDoc: number) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        setEliminarDoc(false);
        setEliminandoDoc(true);
        setErrorSubida(false);
        setTimeout(() => {
            QuitarContratoManualLogic(selEliminarDocumentos, _params.rut, _params.idProceso);
        }, 2000);
    }

    const selEliminarDocumentos = (error: Boolean, err: string, result: boolean) => {
        if (error === false && result !== undefined) {
            /* console.log(result) */
        }
        setEliminandoDoc(false);
        ObtenerListadoDocumentos();
    }
    const classes = useStyles();

    const refrescar = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (_params.codigoNegocio == 1) {
            history.push({
                pathname: "/matricula",
                state: {
                    'rut': _params.rut,
                    'codCarrera': _params.codCarrera,
                    'codigoNegocio': 1,
                    'codigoPlanificacionAcademica': _params.codigoPlanificacionAcademica,
                    'codsede': _params.codsede,
                    'nombreCarrera': _params.nombreCarrera,
                    'numeroAlumno': _params.numeroAlumno,
                    'nombreAlumno': _params.nombreAlumno,
                    'anioPromocion': _params.anioPromocion,
                    'periodoPromocion': _params.periodoPromocion,
                    'idProceso': _params.idProceso,
                    'menu': "6",
                    'idPersona': _params.idPersona
                }
            })

            window.location.reload()
        } else {
            history.push({
                pathname: "/matricula",
                state: {
                    'rut': _params.rut,
                    'codCarrera': _params.codCarrera,
                    'codigoNegocio': _params.codigoNegocio,
                    'codigoPlanificacionAcademica': _params.codigoPlanificacionAcademica,
                    'codsede': _params.codsede,
                    'nombreCarrera': _params.nombreCarrera,
                    'numeroAlumno': _params.numeroAlumno,
                    'nombreAlumno': _params.nombreAlumno,
                    'anioPromocion': _params.anioPromocion,
                    'periodoPromocion': _params.periodoPromocion,
                    'idProceso': _params.idProceso,
                    'menu': "6",
                    'codComercio': _params.codComercio,
                    'rutRF': _params.rutRF,
                    'debeFirmar': _params.debeFirmar,
                    'idPersona': _params.idPersona
                }
            })

            window.location.reload()
        }
    }

    return (
        <>
            {
                error ?
                    <div className="site-main__container">
                        <div className="enrollment__title">Firma de contrato</div>
                        <div style={{ marginBottom: '2rem', color: 'gray', fontSize: 12 }}>
                            <div className="enrollment__subtitle"></div>
                        </div>
                        <div style={{ textAlign: 'center', marginTop: 100 }}>

                            <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                            <br />
                            <a><span>Ocurrió un problema al obtener tus firmas, favor comunicarse con la universidad.</span></a>
                            <br />
                            <Button style={{ border: '1px solid gray' }} onClick={() => setReintentar(true)} color="inherit">Reintentar cargar firmas</Button>
                        </div>
                    </div>
                    :
                    <main className="site-main enrollment">

                        {cargandoValores ?
                            <div className="site-main__container">
                                <div style={{ textAlign: 'center', marginTop: 100 }}>
                                    <CircularProgress disableShrink />
                                    <br />
                                    <a><span>Cargando datos</span></a>
                                </div>
                            </div>
                            :
                            <div className="site-main__container">
                                <div style={{ marginTop: '-3rem', marginBottom: '1rem' }} >
                                    {
                                        codigoNegocio === 1 ?
                                            <div style={{ marginBottom: '2rem', color: 'gray', fontSize: '1rem' }}>
                                                <div className="enrollment__subtitle">A continuación el alumno y responsable financiero deberán firmar el Contrato de Servicios Educacionales mediante firma electrónica simple.</div>
                                            </div>
                                            :
                                            <div style={{ marginBottom: '2rem', color: 'gray', fontSize: '1rem' }}>
                                                {/* <div className="enrollment__subtitle">A continuación el alumno/responsable financiero deberá firmar el Contrato de Servicios Educacionales mediante firma electrónica simple, de lo contrario, no podrá finalizar el proceso de matrícula.</div> */}
                                                <div className="enrollment__subtitle">Para finalizar el proceso de matrícula, el alumno/responsable financiero deberá firmar el Contrato de Servicios Educacionales mediante firma electrónica seleccionando sobre el nombre del alumno/responsable financiero.</div>
                                                <div className="enrollment__subtitle">El contrato a firmar electrónicamente lo puede revisar en VISUALIZAR CONTRATO el que será enviado al mail una vez finalizado el proceso de matrícula.</div>
                                            </div>
                                    }
                                </div>
                                <div className={classes.root}>
                                    <Grid container spacing={3} direction="column">
                                        <Grid container item xs={12} direction="row" /* justifyContent="center" alignItems="stretch" */>
                                            <div>
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        1.- Visualizar contrato
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={3} direction="column">
                                        <Grid container item xs={12} direction="row" /* justifyContent="center" alignItems="stretch" */>
                                            <div>
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button
                                                            className="printing-documents__download-btn"
                                                            variant="contained"
                                                            onClick={handleVisualizarContrato}
                                                            color="primary"
                                                            disabled={cargandoContrato}
                                                            style={{ width: '13rem' }}
                                                        >
                                                            {cargandoContrato ? <CircularProgress color="inherit" size={20} disableShrink /> : "Visualizar contrato"}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid container spacing={3} direction="column">
                                        {loading && (<CircularProgress size={40} className={classes.buttonProgress} />)}
                                        <Grid container item xs={12} direction="row" justifyContent="center" alignItems="stretch">
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    2.- Firmas
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {
                                            tieneExcepcion ?
                                                <p style={{ marginLeft: 40 }}>
                                                    <p>Pasos a seguir:</p>
                                                    <p style={{ marginLeft: 10 }}>1.- <strong>Descargar contrato.</strong></p>
                                                    <p style={{ marginLeft: 10 }}>2.- <strong>Firmar contrato manualmente.</strong></p>
                                                    <p style={{ marginLeft: 10 }}>3.- <strong>Escanear documento.</strong></p>
                                                    <p style={{ marginLeft: 10 }}>4.- <strong>Cargar documento en formato PDF.</strong></p>
                                                    <p style={{ marginLeft: 10 }}>5.- <strong>El contrato firmado manualmente debe ser entregado en original en la Oficina de Matrícula de la sede respectiva.</strong></p>
                                                </p>
                                                :
                                                ""
                                        }
                                        {
                                            tieneExcepcion ?
                                                <div style={{ marginLeft: '4rem' }}>
                                                    {
                                                        eliminandoDoc ?
                                                            <div><CircularProgress size={18} disableShrink /> <label>&nbsp;&nbsp;Eliminando Documento.</label></div>
                                                            :
                                                            subiendoDoc ?
                                                                <div><CircularProgress size={18} disableShrink /> <label>&nbsp;&nbsp;Subiendo Documento.</label></div>
                                                                :
                                                                allUploaded ?
                                                                    <table className={"payment-selection__table table"}>
                                                                        <thead>
                                                                            <th className="text-left w-80 noWrap">Nombre Documento</th>
                                                                            <th className="text-left w-20">Acciones</th>
                                                                        </thead>
                                                                        <tr>
                                                                            <td><label>Contrato Firma Manual</label></td>
                                                                            <td>
                                                                                <ViewIcons onClick={() => {
                                                                                    VerContratoManual()
                                                                                }} />&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                <DeleteIcons onClick={() => {
                                                                                    setEliminarDoc(true)
                                                                                }} />{/* 
                                                                                <button
                                                                                    className="btn btn-link"
                                                                                    type="button"
                                                                                    style={{ float: 'right', color: 'gray' }}
                                                                                    onClick={() => {
                                                                                        setEliminarDoc(true)
                                                                                    }}>
                                                                                    Eliminar
                                                                                </button> */}</td>
                                                                        </tr>
                                                                    </table>
                                                                    :
                                                                    <input
                                                                        type="file"
                                                                        key={docSubido}
                                                                        style={{ width: '100%', fontSize: 14 }}
                                                                        name={`Contrato/4`}
                                                                        onChange={handleFileInputChange}
                                                                    />
                                                    }
                                                    <br />
                                                    {
                                                        formatoIncorrecto ?
                                                            <Alert style={{ width: '90%' }} variant="outlined" severity="warning">{txtformatoIncorrecto}{/* Formato del documento solo puede ser PDF o JPG */}</Alert>
                                                            :
                                                            ""
                                                    }
                                                    {
                                                        errorsubida ?
                                                            <Alert style={{ width: '90%' }} variant="outlined" severity="error"> Se ha producido un error al intentar cargar el documento. </Alert>
                                                            :
                                                            ""
                                                    }

                                                    {
                                                        eliminarDoc ?
                                                            <Alert style={{ width: '90%' }} variant="outlined" severity="error">
                                                                <div>
                                                                    ¿ Está seguro de eliminar este documento ?&nbsp;&nbsp;
                                                                    <button style={{ border: '1px solid gray', fontSize: 12 }} className="btn" onClick={() => EliminarDocumentos(4)} >Si</button>
                                                                    &nbsp;<button style={{ border: '1px solid gray', fontSize: 12 }} className="btn" onClick={() => setEliminarDoc(false)} >No</button>
                                                                </div>
                                                            </Alert> : ""
                                                    }
                                                </div>
                                                :
                                                <>
                                                    <Grid container item xs={12} direction="row" justifyContent="center" alignItems="stretch">
                                                        <Grid container>
                                                            <Grid item xs={1}>
                                                                <div style={{ float: 'right' }}>
                                                                    {check1 ? <CheckCircleOutline style={{ color: '#0062a1' }} /> : ""}
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={11} >
                                                                {firmado1 ?
                                                                    <h5 style={{ fontSize: '1rem', color: 'gray', fontWeight: 400 }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Firma {nombre1}: {runFormato1} / {nombreCompleto1}</h5>
                                                                    :
                                                                    <div>
                                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                        <Link style={{ cursor: 'pointer' }} onClick={() => handleFirmaContrato()} >
                                                                            Firma {nombre1}: {runFormato1} / {nombreCompleto1}
                                                                        </Link>
                                                                    </div>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    {
                                                        notieneRF ?
                                                            ""
                                                            :
                                                            <Grid container item xs={12} direction="row" justifyContent="center" alignItems="stretch">
                                                                <Grid container>
                                                                    <Grid item xs={1}>
                                                                        <div style={{ float: 'right' }}>
                                                                            {check2 ? <CheckCircleOutline style={{ color: '#0062a1' }} /> : ""}
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={11}>
                                                                        {firmado2 ?
                                                                            <h5 style={{ fontSize: '1rem', color: 'gray', fontWeight: 400 }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Firma {nombre2}: {runFormato2} / {nombreCompleto2}</h5>
                                                                            :
                                                                            <div>
                                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                <Link style={{ cursor: 'pointer' }} onClick={() => handleFirmaContrato2()}>
                                                                                    Firma {nombre2}: {runFormato2} / {nombreCompleto2}
                                                                                </Link>
                                                                            </div>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                    }
                                                    {
                                                        !esMenorEdad ?
                                                            ""
                                                            :
                                                            <Grid container item xs={12} direction="row" justifyContent="center" alignItems="stretch">
                                                                <Grid container>
                                                                    <Grid item xs={1}>
                                                                        <div style={{ float: 'right' }}>
                                                                            {check3 ? <CheckCircleOutline style={{ color: '#0062a1' }} /> : ""}
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={11}>
                                                                        {firmado3 ?
                                                                            <h5 style={{ fontSize: '1rem', color: 'gray', fontWeight: 400 }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Firma {nombre3}: {runFormato3} / {nombreCompleto3}</h5>
                                                                            :
                                                                            <div>
                                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                <Link style={{ cursor: 'pointer' }} onClick={() => handleFirmaContrato3()}>
                                                                                    Firma {nombre3}: {runFormato3} / {nombreCompleto3}
                                                                                </Link>
                                                                            </div>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                    }


                                                </>
                                        }
                                        <Grid container item xs={10} direction="row-reverse" justifyContent="space-evenly" alignItems="stretch">
                                            <div className="printing-documents__upload">
                                            </div>
                                        </Grid>
                                        {
                                            tieneExcepcion ?
                                                <div className="payment-webpay__submit">
                                                    <div className="form-group">
                                                        {((codigoNegocioPostulante === 2 && !notieneRF) || codigoNegocioPostulante === 1 || (codigoNegocioPostulante === 3)) && debeFirmar ?
                                                            <a onClick={() => onClickContinuar("5")} style={{ cursor: 'pointer', marginLeft: '1%' }} /* href="pago-webpay--04.html" */ className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={f1 + "#chevron-left"}></use></svg> Volver a Carga de Documentos</a>
                                                            :
                                                            <a onClick={() => { onClickContinuar("3") }} style={{ cursor: 'pointer', marginLeft: '1%' }} className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={f1 + "#chevron-left"}></use></svg> Volver a Pago</a>
                                                        }
                                                        <label className="submit-btn__label-disabled">Ir a la Generación de Matrícula</label>
                                                        <button style={{ marginRight: 15 }} onClick={() => UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 6)} disabled={!allUploaded} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit">Continuar</button>
                                                    </div>
                                                </div>
                                                :
                                                notieneRF ?
                                                    <Grid container item xs={12} direction="row" justifyContent="flex-end" alignItems="stretch">
                                                        <Grid container>
                                                            <Grid item xs={7}>
                                                                <a onClick={() => onClickContinuar("4")} style={{ cursor: 'pointer', marginLeft: '1%' }}  /* href="pago-webpay--04.html" */ className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={f1 + "#chevron-left"}></use></svg> Volver a Pago</a>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <Grid container item xs={12} direction="row" justifyContent="flex-end" alignItems="stretch">
                                                        <Grid container>
                                                            <Grid item xs={7}>
                                                                <a onClick={() => onClickContinuar("5")} style={{ cursor: 'pointer', marginLeft: '1%' }}  /* href="pago-webpay--04.html" */ className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={f1 + "#chevron-left"}></use></svg> Volver a Carga de Documentos</a>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                        }
                                    </Grid>
                                </div>
                            </div>}

                    </main>}
            <div>
                <Dialog open={openIFrameAlumno}
                    onClose={() => setOpenIFrameAlumno(false)}
                    maxWidth={"xl"}
                    aria-labelledby="draggable-dialog-title">
                    <DialogContent>
                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                            {
                                <div style={{ textAlign: 'center', padding: 20 }}>
                                    <CircularProgress disableShrink />
                                    <br />
                                    <br />
                                    <h4><span>Realizando firma eCert {nombre1}.</span></h4>
                                    <br />
                                </div>
                            }
                        </div>
                    </DialogContent>
                </Dialog>
                <Dialog open={openIFrameRF}
                    onClose={() => setOpenIFrameRF(false)}
                    maxWidth={"xl"}
                    aria-labelledby="draggable-dialog-title">
                    <DialogContent>
                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                            {
                                <div style={{ textAlign: 'center', padding: 20 }}>
                                    <CircularProgress disableShrink />
                                    <br />
                                    <br />
                                    <h4><span>Realizando firma eCert {nombre2}.</span></h4>
                                    <br />
                                </div>
                            }
                        </div>
                    </DialogContent>
                </Dialog>
                <Dialog open={openIFrameRL}
                    onClose={() => setOpenIFrameRL(false)}
                    maxWidth={"xl"}
                    aria-labelledby="draggable-dialog-title">
                    <DialogContent>
                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                            {
                                <div style={{ textAlign: 'center', padding: 20 }}>
                                    <CircularProgress disableShrink />
                                    <br />
                                    <br />
                                    <h4><span>Realizando firma eCert {nombre3}.</span></h4>
                                    <br />
                                </div>
                            }
                        </div>
                    </DialogContent>
                </Dialog>
                <Dialog open={openRespuesta}
                    onClose={() => setOpenRespuesta(false)}
                    /* maxWidth={"xs"} */
                    aria-labelledby="draggable-dialog-title">
                    <DialogContent>
                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                            {ok === '0' ?
                                <div style={{ textAlign: 'center', padding: 100 }}>

                                    <CheckCircleOutline style={{ fontSize: 100, color: '#0062a1' }} />
                                    <br />
                                    <h1><span>Servicio</span></h1>
                                    <h3><span>Su firma se ha registrado correctamente.</span></h3>

                                </div>
                                :
                                <div style={{ textAlign: 'center', padding: 50 }}>

                                    <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                    <br />
                                    {/* <h1><span>Servicio</span></h1>
                                    <h3><span>No ha respondido correctamente la cantidad de preguntas solicitadas.</span></h3> */}
                                    <h1><span>Servicio</span></h1>
                                    <h3><span>No hemos podido validar su identidad.</span></h3>
                                    <h5><span>Por favor intente nuevamente o comuníquese al 800 200 125.</span></h5>
                                </div>}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => {
                            setOpenRespuesta(false)
                        }} color="primary" >Salir</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={errorVentanasEmergentes}
                    maxWidth={"xl"}
                    aria-labelledby="draggable-dialog-title">
                    <DialogContent>
                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                            {
                                <div style={{ textAlign: 'center', padding: 20 }}>
                                    <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                    <br />
                                    <br />
                                    <h4><span>Ventanas emergentes bloqueadas.</span></h4>
                                    <br />
                                    <a href="https://support.google.com/chrome/answer/95472?hl=es&co=GENIE.Platform%3DDesktop&oco=0" target="_blank">¿ Como resolverlo ?</a>
                                </div>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => {
                            refrescar();
                            //window.location.reload()
                        }} color="primary" >Salir</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={errorEtapas}
                    maxWidth={"xl"}
                    aria-labelledby="draggable-dialog-title">
                    <DialogContent>
                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                            {
                                <div style={{ textAlign: 'center', padding: 20 }}>
                                    <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                    <br />
                                    <br />
                                    <h4><span>Es necesario finalizar todas las etapas anteriores para poder realizar la firma digital.</span></h4>
                                    <br />
                                </div>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => {
                            setErrorEtapas(false)
                        }} color="primary" >Salir</Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={mnsjeCert}
                    onClose={() => setMnsjeCert(false)}
                    /* maxWidth={"xs"} */
                    aria-labelledby="draggable-dialog-title">
                    <DialogContent>
                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                            <div style={{ textAlign: 'center' }}>

                                <CheckCircleOutline style={{ fontSize: 100, color: '#0062a1' }} />
                                <br />
                                <h1><span>Importante</span></h1>
                                <h3><span>{con.mensajeeCert()}</span></h3>

                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => {
                            setMnsjeCert(false)
                        }} color="primary" >Salir</Button>
                    </DialogActions>
                </Dialog>
            </div>
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    )
}
